import { PACKAGE_PREFIX } from './constants';
export var FETCH_MENU_ACTION_SAGA = "".concat(PACKAGE_PREFIX, "/FETCH_MENU_ACTION_SAGA");
export var fetchMenuActionSaga = function (payload) { return ({
    type: FETCH_MENU_ACTION_SAGA,
    payload: payload,
}); };
export var SET_MENU_DATA = "".concat(PACKAGE_PREFIX, "/SET_MENU_DATA");
export var setMenuAction = function (payload) { return ({
    type: SET_MENU_DATA,
    payload: payload,
}); };
export var SET_PRODUCTS_DATA = "".concat(PACKAGE_PREFIX, "/SET_PRODUCTS_DATA");
export var setProductsAction = function (payload) { return ({
    type: SET_PRODUCTS_DATA,
    payload: payload,
}); };
export var SET_SELECTED_MENU_ITEM = "".concat(PACKAGE_PREFIX, "/SET_SELECTED_MENU_ITEM");
export var setSelectedMenuItemAction = function (payload) { return ({
    type: SET_SELECTED_MENU_ITEM,
    payload: payload,
}); };
export var SET_LOADING_START = "".concat(PACKAGE_PREFIX, "/SET_LOADING_START");
export var setLoadingStartAction = function () { return ({
    type: SET_LOADING_START,
}); };
export var SET_LOADING_STOP = "".concat(PACKAGE_PREFIX, "/SET_LOADING_STOP");
export var setLoadingStopAction = function () { return ({
    type: SET_LOADING_STOP,
}); };
export var PRELOAD_ROUTE_ACTION = "".concat(PACKAGE_PREFIX, "/PRELOAD_ROUTE_ACTION");
export var preloadRouteAction = function (payload) { return ({
    type: PRELOAD_ROUTE_ACTION,
    payload: payload,
}); };
export var NAVIGATE_TO_PRODUCT_SAGA = "".concat(PACKAGE_PREFIX, "/NAVIGATE_TO_PRODUCT_SAGA");
export var navigateToProductActionSaga = function (payload) { return ({
    type: NAVIGATE_TO_PRODUCT_SAGA,
    payload: payload,
}); };
export var CHECK_REFRESH_MENU_START_ACTION_SAGA = "".concat(PACKAGE_PREFIX, "/CHECK_REFRESH_MENU_START_ACTION_SAGA");
export var checkRefreshMenuStartActionSaga = function (payload) { return ({
    type: CHECK_REFRESH_MENU_START_ACTION_SAGA,
    payload: payload,
}); };
export var CHECK_REFRESH_MENU_STOP_ACTION_SAGA = "".concat(PACKAGE_PREFIX, "/CHECK_REFRESH_MENU_STOP_ACTION_SAGA");
export var checkRefreshMenuStopActionSaga = function () { return ({
    type: CHECK_REFRESH_MENU_STOP_ACTION_SAGA,
}); };
export var SET_RELOAD_NOTIFICATION_IS_SHOWN = "".concat(PACKAGE_PREFIX, "/SET_RELOAD_NOTIFICATION_IS_SHOWN");
export var setReloadNotificationIsShownAction = function () { return ({
    type: SET_RELOAD_NOTIFICATION_IS_SHOWN,
}); };
